export default __webpack_public_path__ + "static/keeping-your-skin-fresh-on-a-long-haul-flight-d667264d88400125f21a7342f5fd1a6c.jpg";